<template>
  <div v-if="isAdmin">
    <v-data-table
      :headers="columns"
      :items="items"
      sort-by="id"
      class="elevation-1"
    >
      <template v-slot:top left>
        <v-container>
          <v-row>
            <v-col position="top left">
              <v-alert
                border="bottom"
                type="success"
                label="Info"
                :value="showMessage"
                hide-details="auto"
                >{{ message }}</v-alert
              >
              <v-alert
                border="bottom"
                type="error"
                label="Error"
                :value="showError"
                hide-details="auto"
                >{{ error }}</v-alert
              >
            </v-col>
          </v-row>
        </v-container>
        <v-toolbar flat color="#00427f" extended extension-height="6">
          <v-toolbar-title style="color: #ffffff">
            <span>
              <strong>Customer remote solution - key users portal</strong></span
            ></v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical color="#FFFFFF"></v-divider>
          <v-spacer></v-spacer>
          <template v-slot:extension>
            <v-fab-transition>
              <v-btn
                color="#3C9845"
                fab
                dark
                absolute
                small
                top
                right
                @click="dialog = !dialog"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-fab-transition>
          </template>

          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-form v-model="valid" ref="form">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="Item.country"
                        :items="countries"
                        item-text="name"
                        item-value="code"
                        label="Country"
                        persistent-hint
                        return-object
                        single-line
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        required
                        v-model="Item.accountName"
                        label="Account name"
                        :change="validate"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        required
                        v-model="Item.location"
                        label="Location"
                        :change="validate"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row><v-divider></v-divider></v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        required
                        v-model="Item.stackName"
                        label="Stack Name"
                        :rules="stackNameRule"
                        :change="validate"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        required
                        v-model="Item.fleetName"
                        label="Fleet Name"
                        :rules="fleetNameRule"
                        :change="validate"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        required
                        v-model="Item.nameVPN"
                        label="VPN Name"
                        :rules="vpnRule"
                        :change="validate"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-file-input
                        v-model="files"
                        multiple
                        label="Config files"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    :disabled="!valid"
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">
                Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <router-link :to="{ name:'fleet', params:{id:item.id} }" class="nav-link">
          {{item.id}}
        </router-link>
      </template>
      <template v-slot:[`item.timestamp`]="{ item }">
        <span>{{ new Date(item.timestamp).toLocaleString() }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
  <div v-else>
    <v-alert
      border="bottom"
      type="error"
      label="Error"
      :value="showError"
      hide-details="auto"
      >{{ error }}</v-alert
    >
  </div>
</template>

<script>
import { API, Auth, Storage } from "aws-amplify";
import countries from "./countries.json";
export default {
  data() {
    return {
      isAdmin: false, 
      countries,
      vpnRule: [(v) => !!v || "VPN name is required"],
      stackNameRule: [(v) => !!v || "Stack name is required"],
      fleetNameRule: [(v) => !!v || "Fleet name is required"],
      siteRule: [(v) => !!v || "Site is required"],
      listSize: [5, 10, 15, 100],
      valid: true,
      hidden: false,
      message: "",
      showMessage: false,
      showError: false,
      error: "",
      files: [],
      editedIndex: -1,
      idEdit: null,
      items: [],
      dialog: false,
      dialogDelete: false,

      columns: [
        {
          align: "start",
          sortable: false,
        },
        { text: "Country", value: "country.name" },
        { text: "Account Name", value: "accountName" },
        { text: "Location", value: "location", divider: true },
        { text: "Id", value: "id" },
        { text: "Stack Name", value: "stackName" },
        { text: "VPN Name", value: "nameVPN" },
        { text: "Timestamp", value: "timestamp" },
        { text: "FleetName", value: "fleetName" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      Item: {
        country: "",
        accountName: "",
        location: "",
        stackName: "",
        nameVPN: "",
        fleetName: "",
      },
      defaultItem: {
        country: "",
        accountName: "",
        location: "",
        stackName: "",
        nameVPN: "",
        fleetName: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  async mounted() {
    try {
      if (!this.$route.params && this.$route.params.id) {
        this.error = "Access to fleet impossible: Invalid parameter";
        this.showError = true;
      }
      this.isAdmin = false;
      this.user = await Auth.currentAuthenticatedUser();
      this.attributes = await Auth.userAttributes(this.user);
      this.attributes.forEach((attribute) => {
        if (attribute["Name"] && attribute["Name"] === "custom:rolevilink") {
          if (attribute["Value"].includes("ViLinkBastionAdmin")) this.isAdmin = true;
        }
      });
      if (!this.isAdmin) {
        this.$router.push({ path: "/error" });
      }
      API.get(process.env.VUE_APP_API_NAME, process.env.VUE_APP_API_PATH, {})
        .then((result) => {
          this.items = result.Items;
        })
        .catch((err) => {
          if (
            !err.response ||
            !err.response.data ||
            !err.response.data.message
          ) {
            this.error = err;
          } else {
            this.error = err.response.data.message;
          }
          this.showError = true;
        });
    } catch (error) {
      this.error = "Access to fleet impossible: Invalid parameter";
      this.showError = true;
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    async save() {
      if (this.editedIndex === -1) {
        API.post(process.env.VUE_APP_API_NAME, process.env.VUE_APP_API_PATH, {
          body: this.Item,
        })
          .then((response) => {
            if (!response || !response.data || !response.data.id) {
              this.error = "No response found";
              this.showError = true;
            } else {
              try {
                this.files.forEach(async (file) => {
                  await Storage.put(response.data.id + "/" + file.name, file);
                });
                this.files=[]
              } catch (error) {
                if (
                  !error.response ||
                  !error.response.data ||
                  !error.response.data.message
                ) {
                  this.error = error;
                } else {
                  this.error = error.response.data.message;
                }
                this.showError = true;
              }
              this.message =
                "The item has been successfully created. The URL to use this configuration is :  " +
                process.env.VUE_APP_URL_USER +
                "/fleet/" +
                response.data.id;
              this.showMessage = true;
              this.items.push(response.data);
              this.Item = Object.assign({}, this.defaultItem);
            }
          })
          .catch((err) => {
            if (
              !err.response ||
              !err.response.data ||
              !err.response.data.message
            ) {
              this.error = err;
            } else {
              this.error = err.response.data.message;
            }
            this.showError = true;
          });
      } else {
        API.put(
          process.env.VUE_APP_API_NAME,
          process.env.VUE_APP_API_PATH + "/" + String(this.Item.id),
          { body: this.Item }
        )
          .then(
            function (response) {
              if (response == null) {
                this.error = "No response found";
                this.showError = true;
              } else {
                this.files.forEach(async (file) => {
                  await Storage.put(this.Item.id + "/" + file.name, file);
                });
                this.files=[]
                this.message = response.message;
                this.showMessage = true;
                this.$set(this.items, this.editedIndex, this.Item);
                this.Item = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
              }
            }.bind(this)
          )
          .catch((err) => {
            if (
              !err.response ||
              !err.response.data ||
              !err.response.data.message
            ) {
              this.error = err;
            } else {
              this.error = err.response.data.message;
            }
            this.showError = true;
          });
      }
      this.dialog = false;
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.Item = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.Item = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      API.del(
        process.env.VUE_APP_API_NAME,
        process.env.VUE_APP_API_PATH + "/" + String(this.Item.id),
        {}
      )
        .then((result) => {
          this.message = result.message;
          this.showMessage = true;
        })
        .catch((err) => {
          if (
            !err.response ||
            !err.response.data ||
            !err.response.data.message
          ) {
            this.error = err;
          } else {
            this.error = err.response.data.message;
          }
          this.showError = true;
        });
      this.items.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.Item = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.Item = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    loadInput(column) {
      return this.Item[column];
    },
  },
};
</script>
